<template>
  <app-page-title :color="'sun'" class="_pb0 _pt0">
    <template #pageTitleLeft>
      <h1 class="_mb0 _mt0">Billing</h1>
    </template>
    <template #pageTitleRight>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'
  import billing from '@mixins/billing'

  export default {
    mixins: [billing],
    components: {
      AppPageTitle
    }
  }
</script>
